jQuery(document).ready(function ($) {
  /**
   * Mobile Menu: toggle active state
   */
  $(document).on("click", ".list-menu__item span", function () {
    $(this).closest(".list-menu__item").toggleClass("active_item");
  });

  /**
   * Announcement Slider (Flickity) – SAFE INIT
   * Prevents "flickity is not a function" from crashing other scripts (e.g. predictive search)
   */
  var $announceSlider = $(".annouce-slider");
  if ($announceSlider.length) {
    if ($.fn && typeof $.fn.flickity === "function") {
      $announceSlider.flickity({
        contain: true,
        pageDots: false,
        prevNextButtons: false,
        autoPlay: 5000,
        wrapAround: true,
      });
    } else {
      // Optional: keep as warning for debugging (can be removed)
      console.warn("[custom.js] Flickity not loaded – announcement slider skipped");
    }
  }

  /**
   * Back to top button
   */
  var $backToTop = $(".back-to-top");
  if ($backToTop.length) {
    $backToTop.hide();

    $(window).on("scroll", function () {
      if ($(this).scrollTop() > 100) {
        $backToTop.fadeIn();
      } else {
        $backToTop.fadeOut();
      }
    });

    $backToTop.on("click", function (e) {
      e.preventDefault();
      $("html, body").animate({ scrollTop: 0 }, 500);
    });
  }

  /**
   * Collection view toggle (grid/list)
   */
  var $gridContainer = $(".product-grid-container");
  var $productGrid = $("#product-grid");

  if ($gridContainer.length && $productGrid.length) {
    $gridContainer.addClass("grid-view-section");

    $(document).on("click", ".grid-view", function (e) {
      e.preventDefault();
      $(".grid-view").addClass("active");
      $(".list-view").removeClass("active");

      $gridContainer
        .removeClass("list-view-section1")
        .addClass("grid-view-section");

      $productGrid
        .removeClass("grid--4-col-desktop grid--2-col-tablet-down")
        .addClass("grid--2-col-desktop grid--1-col-tablet-down");
    });

    $(document).on("click", ".list-view", function (e) {
      e.preventDefault();
      $(".list-view").addClass("active");
      $(".grid-view").removeClass("active");

      $gridContainer
        .removeClass("grid-view-section")
        .addClass("list-view-section1");

      $productGrid
        .removeClass("grid--2-col-desktop grid--1-col-tablet-down")
        .addClass("grid--4-col-desktop grid--2-col-tablet-down");
    });
  }
});
